<!-- Só interpolação: motivo, antes e depois são texto do agente (ver o JSDoc do componente). -->
<section class="revision" aria-labelledby="briefing-revision-title">
  @if (summary().regenerated) {
    <p id="briefing-revision-title" class="revision__summary revision__summary--static">
      <span class="revision__badge" aria-hidden="true"><i class="pi pi-sync"></i></span>
      <span class="revision__summary-text">
        <strong>Refeita por inteiro desde a {{ previousLabel() }}</strong
        >{{ summary().reason ? ': ' + summary().reason : '.' }}
      </span>
    </p>
  } @else {
    <button
      id="briefing-revision-title"
      type="button"
      class="revision__summary"
      aria-controls="briefing-revision-list"
      [attr.aria-expanded]="expanded()"
      (click)="toggle()">
      <span class="revision__badge" aria-hidden="true"><i class="pi pi-history"></i></span>
      <span class="revision__summary-text">
        <strong>Mudou desde a {{ previousLabel() }}:</strong>
        @if (headline().highlight; as highlight) {
          {{ highlight }} ·
        }
        {{ headline().count }}
      </span>
      <i
        class="pi pi-chevron-down revision__chevron"
        [class.revision__chevron--open]="expanded()"
        aria-hidden="true"></i>
    </button>

    @if (expanded()) {
      <!-- Abre para cima, sobre a prévia (o pé do leitor é a âncora), como painel com sombra (Q11). -->
      <div class="revision__panel">
        <p class="revision__panel-title">Mudou desde a {{ previousLabel() }}</p>
        <ol id="briefing-revision-list" class="revision__list">
          @for (item of rows(); track $index; let i = $index) {
            <li class="revision__item">
              <button
                type="button"
                class="revision__row"
                [attr.aria-expanded]="openIndex() === i"
                [attr.aria-controls]="'briefing-revision-row-' + i"
                (click)="toggleRow(i)">
                <span class="revision__number" aria-hidden="true">{{ i + 1 }}</span>
                <span class="revision__label">{{ item.row.label }}</span>
                @if (item.short; as short) {
                  <span class="revision__short">
                    {{ short.before }}
                    <i class="pi pi-arrow-right" aria-hidden="true"></i>
                    <span class="revision__sr">para</span>
                    <strong>{{ short.after }}</strong>
                  </span>
                }
                <i
                  class="pi pi-chevron-down revision__chevron"
                  [class.revision__chevron--open]="openIndex() === i"
                  aria-hidden="true"></i>
              </button>

              @if (openIndex() === i) {
                <div class="revision__detail" [id]="'briefing-revision-row-' + i">
                  @switch (item.row.kind) {
                    @case ('omitted') {
                      <p class="revision__note">Trecho longo demais para mostrar aqui.</p>
                    }
                    @case ('added') {
                      <p class="revision__side revision__side--after">
                        <span class="revision__side-label">Incluído</span>
                        <ng-container
                          *ngTemplateOutlet="plain; context: { $implicit: item.row.after }" />
                      </p>
                    }
                    @case ('removed') {
                      <p class="revision__side revision__side--before">
                        <span class="revision__side-label">Removido</span>
                        <ng-container
                          *ngTemplateOutlet="plain; context: { $implicit: item.row.before }" />
                      </p>
                    }
                    @default {
                      @if (item.diff; as diff) {
                        <!-- B3: só as palavras trocadas marcadas (antiga riscada, nova destacada); o resto em texto
                             normal, recortado em "..." longe da mudança. -->
                        @if (diff.before.length) {
                          <p class="revision__side revision__side--before">
                            <span class="revision__side-label">Antes</span>
                            @for (part of diff.before; track $index) {
                              @if (part.changed) {
                                <del>{{ part.text }}</del>
                              } @else {
                                <span [class.revision__elided]="part.elided">{{ part.text }}</span>
                              }
                            }
                          </p>
                        }
                        <p class="revision__side revision__side--after">
                          <span class="revision__side-label">Depois</span>
                          @for (part of diff.after; track $index) {
                            @if (part.changed) {
                              <mark>{{ part.text }}</mark>
                            } @else {
                              <span [class.revision__elided]="part.elided">{{ part.text }}</span>
                            }
                          }
                        </p>
                      } @else {
                        <p class="revision__side revision__side--before">
                          <span class="revision__side-label">Antes</span>
                          <ng-container
                            *ngTemplateOutlet="plain; context: { $implicit: item.row.before }" />
                        </p>
                        <p class="revision__side revision__side--after">
                          <span class="revision__side-label">Depois</span>
                          <ng-container
                            *ngTemplateOutlet="plain; context: { $implicit: item.row.after }" />
                        </p>
                      }
                    }
                  }
                </div>
              }
            </li>
          }
        </ol>

        @if (summary().omittedCount > 0) {
          <p class="revision__note revision__note--footer">
            E mais {{ summary().omittedCount }}
            {{
              summary().omittedCount === 1
                ? 'mudança que não pôde ser listada.'
                : 'mudanças que não puderam ser listadas.'
            }}
          </p>
        }
      </div>
    }
  }
</section>

<!-- Valor inteiro (incluído, removido, lista ou objeto): texto corrido ou JSON num bloco de código (dentro de <p>,
     por isso <code> e não <pre>). Sempre interpolado. -->
<ng-template #plain let-value>
  @if (value) {
    @if (value.structured) {
      <code class="revision__structured">{{ value.text }}</code>
    } @else {
      {{ value.text }}
    }
  } @else {
    <span class="revision__note">sem valor</span>
  }
</ng-template>
